<header class="header">
    <div class="header-left">
        <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">
        <h5>Cambio Contraseña: Por razones de seguridad deberá cambiar su clave de acceso.</h5>
    </div>
    <div class="header-right">
        <a class="btn txt-oscuro" href="javascript:void(0);"  (click)="logout()"><span title="Cerrar sesión"
                class="fas fa-sign-out-alt"></span></a>
    </div>
</header>
@if(reiniciando){
<div class="loading-overlay">
    <div class="loading-indicator">Cerrando sesión...</div>
</div>
}



<div class="container-fluid">


    <div class="d-flex align-items-center justify-content-center min-vh-80 bg-light p-3">
        <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
            <div class="card-body">
                <label for="currentPassword" class="form-label"><b>Cómo crear claves de acceso robustas:</b></label>
                <br />
                No utilice palabras comunes, del diccionario, ni nombres de fácil deducción por
                terceros.
                <br />
                No las vincule a un dato personal.
                <br />
                No utilice como contraseña su nombre de usuario ni derivados del mismo.
                <br />
                Constrúyalas utilizando al menos 12 caracteres.
                <br />
                Combine letras mayúsculas y minúsculas, números y signos.
                <br />
                Use claves distintas para máquinas y/o sistemas diferentes.
                <br />
                Elija una palabra sin sentido, aunque pronunciable.
                <br />
                Elija una clave que no pueda olvidar, para evitar escribirla en alguna parte.
                <br />
                <br />
                <b>IMPORTANTE: El nombre de usuario y contraseña de acceso a la Plataforma Interconexión Autoridades,
                    son intransferibles, su uso y resguardo son de exclusiva responsabilidad del titular de la
                    cuenta.</b>
                <br />
                <br />
                <form [formGroup]="changePassForm" (ngSubmit)="onSubmit()">

                    <div class="form-group row">
                        <div class="col-6">
                            <label for="currentPassword" class="form-label">Contraseña Actual:</label>
                            <div class="input-group">
                                <input type="password" [type]="fieldTextType2 ? 'text' : 'password'"
                                    class="form-control" id="currentPassword" formControlName="currentPassword"
                                    placeholder="Ingrese contraseña actual"
                                    [class.is-invalid]="changePassForm.get('currentPassword')?.invalid && changePassForm.get('currentPassword')?.touched"
                                    required autocomplete="on">
                                <div tabindex="0" class="input-group-append" (click)="toggleFieldTextTypeDos()"
                                    (keypress.enter)="toggleFieldTextTypeDos()">
                                    @if(!fieldTextType2){
                                    <span class="input-group-text">
                                        <i class="fa fa-eye-slash"></i>
                                    </span>
                                    }
                                    @else {
                                    <span class="input-group-text">
                                        <i class="fa fa-eye"></i>
                                    </span>
                                    }
                                </div>
                                @if (changePassForm.get('currentPassword')?.invalid &&
                                changePassForm.get('currentPassword')?.touched) {
                                <div class="invalid-feedback">
                                    @if (changePassForm.get('currentPassword')?.hasError('required')) {
                                    <span> Campo
                                        requerido.</span>
                                    }
                                </div>
                                }

                            </div>

                        </div>

                    </div>

                    <div class="form-group row">
                        <div class="col-6">
                            <label for="newPassword" class="form-label">Nueva Contraseña:</label>
                            <div class="input-group">
                                <input [type]="fieldTextType ? 'text' : 'password'" class="form-control"
                                    id="newPassword" formControlName="newPassword"
                                    placeholder="Ingrese nueva contraseña"
                                    [class.is-invalid]="changePassForm.get('newPassword')?.invalid && changePassForm.get('newPassword')?.touched"
                                    required autocomplete="on">
                                <div tabindex="0" class="input-group-append" (click)="toggleFieldTextType()" (keypress.enter)="toggleFieldTextType()">
                                    @if(!fieldTextType){
                                    <span class="input-group-text">
                                        <i class="fa fa-eye-slash"></i>
                                    </span>
                                    }
                                    @if(fieldTextType){
                                    <span class="input-group-text">
                                        <i class="fa fa-eye"></i>
                                    </span>
                                    }


                                </div>
                                @if(changePassForm.get('newPassword')?.invalid &&
                                changePassForm.get('newPassword')?.touched){
                                <div class="invalid-feedback">
                                    @if(changePassForm.get('newPassword')?.hasError('required')){
                                    <span>Campo requerido.</span>
                                    }
                                    @if(changePassForm.get('newPassword')?.hasError('minlength')){
                                    <span>Mínimo 12 caracteres.</span>
                                    }

                                </div>
                                }



                            </div>

                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-6">
                            <label for="confirmPassword" class="form-label">Confirmar Contraseña:</label>
                            <div class="input-group">
                                <input [type]="fieldTextType3 ? 'text' : 'password'" type="password"
                                    class="form-control" id="confirmPassword" formControlName="confirmPassword"
                                    placeholder="Confirme contraseña"
                                    [class.is-invalid]="changePassForm.get('confirmPassword')?.invalid && changePassForm.get('confirmPassword')?.touched"
                                    required autocomplete="on">
                                <div tabindex="1" class="input-group-append" (click)="toggleFieldTextTypeTres()" (keypress.enter)="toggleFieldTextTypeTres()">
                                    @if(!fieldTextType3){
                                    <span class="input-group-text">
                                        <i class="fa fa-eye-slash"></i>
                                    </span>
                                    }
                                    @if(fieldTextType3){
                                    <span class="input-group-text">
                                        <i class="fa fa-eye"></i>
                                    </span>
                                    }

                                </div>
                                @if(changePassForm.get('confirmPassword')?.invalid &&
                                changePassForm.get('confirmPassword')?.touched){
                                <div class="invalid-feedback">
                                    @if(changePassForm.get('confirmPassword')?.hasError('required')){
                                    <span> Campo requerido.</span>
                                    }
                                </div>
                                }

                            </div>
                        </div>
                    </div>
                    <!--                     <br>
                 <div class="form-group row">
                        <div class="col-12">
                            <label>
                                <input type="checkbox" [(ngModel)]="chkAviPriv" name="opcion1" value="1" formControlName="chkAviPriv">
                                He leído el <a href="https://www.oaj.gob.mx/transparencia/resources/avisosPrivacidad/Aviso_Integral_PortalServiciosLineaPoderJudicialFederacion-2026.pdf" target="_blank">Aviso de Privacidad</a> y otorgo mi consentimiento para que los datos personales
                                sean tratados conforme al mismo.
                            </label>
                        </div>
                    </div>
                    <br>
                     <div class="form-group row">
                        <div class="col-12">
                            <label>
                                <input type="checkbox" [(ngModel)]="chkTerCon" name="opcion2" value="2" formControlName="chkTerCon">
                                He leído y acepto los <a href="assets/doctos/TÉRMINOS Y CONDICIONES DE ADHESIÓN PARA LA INTERCONEXIÓN TECNOLÓGICA.pdf" target="_blank">Términos y Condiciones </a>de Adhesión para la Interconexión Tecnológica.
                            </label>
                        </div>
                    </div>  -->
                    <br>
                    <oaj-alert-itx></oaj-alert-itx>
                    <div style="display: flex; justify-content: flex-end">
                        <!-- <button type="submit" class="btn btn-login" [disabled]="changePassForm.invalid || loading || !chkAviPriv || !chkTerCon"> -->
                        <button type="submit" class="btn btn-login" [disabled]="changePassForm.invalid || loading">
                            @if(!loading){
                            <span>Cambiar Clave de Acceso</span>
                            }
                            @if(loading){
                            <span class="d-flex align-items-center justify-content-center">
                                <span class="spinner-border spinner-border-sm me-2" role="status"
                                    aria-hidden="true"></span>
                                Cambiando...
                            </span>
                            }

                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>